import React, { useState, useEffect } from "react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom"; // Import Link component
import logoBanner from "../assets/images/new_logo_without_font.png";
import axios from '../axiosInstance';
import HighPerformanceAd from "../components/HighPerformanceAd";

function Toast({ message, type = "error", onClose }) {
  return (
    <div className={`fixed top-6 left-1/2 transform -translate-x-1/2 z-50 px-4 py-3 rounded shadow-lg text-white ${type === "error" ? "bg-red-600" : "bg-green-600"}`}>
      <div className="flex items-center space-x-2">
        <span>{message}</span>
        <button onClick={onClose} className="ml-2 text-white hover:text-gray-300 font-bold">×</button>
      </div>
    </div>
  );
}

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [toast, setToast] = useState({ message: "", type: "" });
  const [isResetMode, setIsResetMode] = useState(false);

  const showToast = (message, type = "error") => {
	;
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };
  
const handleSubmit = async () => {
  if (email && password) {
    try {
      // Correction de l'ordre des arguments
      const response = await axios.post(
        `/api/login`, // URL
        { email: email, password: password }, // Corps de la requête (données)
        { withCredentials: true } // Options de configuration (par exemple, pour les cookies)
      );
      onLogin(); // ou navigate("/dashboard"), etc.
    } catch (error) {
      console.error("Login error:", error.message);
      const message =
        error.response?.data?.message || "An unexpected error occurred";
      showToast(message, "error");
    }
  } else {
    showToast("Please fill in all fields", "error");
  }
};

const handleResetPassword = async () => {
  if (!email) return showToast("Please enter your email", "error");

  try {
    await axios.post("/api/reset-password", { email });
    showToast("A new password has been sent to your email", "success");
    setIsResetMode(false);
  } catch (err) {
    console.error(err);
    showToast(err?.response?.data?.message || "Error sending reset email");
  }
};

useEffect(() => {
  document.title = "Login | CoinzUp";
}, []);

return (
  <div className="min-h-screen bg-gray-950 text-white flex flex-col">
    {/* Toast */}
    {toast.message && (
      <Toast
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ message: "", type: "" })}
      />
    )}

    {/* Header */}
    <header className="border-b border-gray-800 px-4 sm:px-6 py-4 flex items-center justify-between">
      <Link to="/index">
        <img src={logoBanner} alt="CoinZUp Logo" className="w-32 sm:w-40 h-auto" />
      </Link>
      <div className="space-x-3 sm:space-x-4 text-sm sm:text-base">
         <Link to="/blog" className="hover:underline">Blog</Link>
        <Link to="/login" className="underline">
          Log In
        </Link>
        <Link
          to="/register"
          className="bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-400 transition"
        >
          Sign Up
        </Link>
      </div>
    </header>

       {/* 🄸🄵🅁🄰🄼🄴 🔽 always visible and responsive */}
       <HighPerformanceAd keyId="fd5da3543c594f07b73630f461f10613" width={728} height={90}/>

    {/* Login Form Section */}
    <main className="flex-grow flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-xl">
        <h2 className="text-2xl font-bold text-white mb-6 text-center">Log In</h2>

        {isResetMode ? (
          <>
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full p-3 mb-3 rounded bg-gray-800 text-white"
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button className="w-full mb-3" onClick={handleResetPassword}>
              Reset Password
            </Button>
            <p
              className="text-center text-sm text-blue-400 cursor-pointer"
              onClick={() => setIsResetMode(false)}
            >
              Back to login
            </p>
          </>
        ) : (
          <>
            <input
              type="email"
              placeholder="Email"
              className="w-full p-3 mb-3 rounded bg-gray-800 text-white"
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              className="w-full p-3 mb-3 rounded bg-gray-800 text-white"
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              className="w-full bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-400 transition mb-3"
              onClick={handleSubmit}
            >
              Log In
            </Button>
            <p
              className="text-center text-sm text-blue-400 cursor-pointer"
              onClick={() => setIsResetMode(true)}
            >
              Forgot password?
            </p>
          </>
        )}

        <div className="text-center text-sm text-gray-400 mt-6">
          Don't have an account?{" "}
          <Link to="/register" className="text-blue-400 hover:underline">
            Create an account
          </Link>
        </div>
      </div>
    </main>
    <HighPerformanceAd keyId="96e99453a24be0353f2fe26dc0b9b728" width={468} height={60}/>
    {/* Footer */}
    <footer className="bg-gray-900/80 text-center text-sm text-gray-500 py-4 border-t border-gray-800">
      © 2025 CoinzUp.net. All rights reserved.&nbsp;
      <Link to="/notice" className="hover:text-white underline">
        Privacy & Legal Notice
      </Link>
      <Link to="/terms" className="hover:text-white underline">
        Terms & Conditions
      </Link>
    </footer>
  </div>
);
}
